import PlatformWrapper from 'client/common/components/platform-wrapper/PlatformWrapper';
import { IPlatformAttributeProps } from 'client/common/components/platform-wrapper/PlatformWrapper.type';
import React from 'react';

function DesktopPlatformWrapper(props: IPlatformAttributeProps) {

    return (
        <PlatformWrapper {...props} platform="desktop" />
    );
}

export default DesktopPlatformWrapper;
